var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import FetchService from "./Shared/FetchService";
import DuplicatePersonDomainService from "../Domain/DuplicatePerson/DuplicatePerson.service";
const BASE_URL = "/aviso/duplicatePerson";
export default class DuplicatePersonService {
    static editIgnore(edit) {
        return __awaiter(this, void 0, void 0, function* () {
            return FetchService.postSingleResponse(BASE_URL + "/editIgnore", {
                ignore: edit.ignore,
                duplicatePersonIds: edit.duplicatePersonIds,
            });
        });
    }
    static isDetectedDuplicateViewRefreshing() {
        return __awaiter(this, void 0, void 0, function* () {
            return FetchService.getSingleResponse(BASE_URL + "/isDetectedDuplicateViewRefreshing");
        });
    }
    static triggerDetectedDuplicateViewRefreshJob() {
        return __awaiter(this, void 0, void 0, function* () {
            return FetchService.postSingleResponse(BASE_URL + "/triggerDetectedDuplicateViewRefreshJob", {});
        });
    }
    static search(search, options = {}) {
        return __awaiter(this, void 0, void 0, function* () {
            const duplicateList = yield FetchService.getPagedResponse(BASE_URL + "/search", {
                query: search.query,
                ids: search.ids,
                personAIds: search.personAIds,
                personBIds: search.personBIds,
                ruleSetIds: search.ruleSetIds,
                personA_IsMergeable: search.personA_IsMergeable,
                personB_IsMergeable: search.personB_IsMergeable,
                ezMerge: search.ezMerge,
                ignored: search.ignored,
                merged: search.merged,
                duplicatedDueToMerge: search.duplicatedDueToMerge,
                personDeleted: search.personDeleted,
                personAPersonTypeInternalNames: search.personAPersonTypeInternalNames,
                personBPersonTypeInternalNames: search.personBPersonTypeInternalNames,
                bothPersonInstitutionPersonId: search.bothPersonInstitutionPersonId,
                bothPersonSecondaryEmailAddress: search.bothPersonSecondaryEmailAddress,
                modifiedDateTo: search.modifiedDateTo,
                modifiedDateFrom: search.modifiedDateFrom,
                createdDateTo: search.createdDateTo,
                createdDateFrom: search.createdDateFrom,
                searchText: search.searchText,
                orderBy: search.orderBy,
                max: options === null || options === void 0 ? void 0 : options.max,
                offset: options === null || options === void 0 ? void 0 : options.offset,
                sort: options === null || options === void 0 ? void 0 : options.sort,
                order: options === null || options === void 0 ? void 0 : options.order,
            });
            return Object.assign(Object.assign({}, duplicateList), { 
                // @ts-expect-error - TS2571 - Object is of type 'unknown'.
                data: duplicateList.data.map(DuplicatePersonDomainService.fromJSON) });
        });
    }
}
